import { Routes } from "@angular/router";
import { WorkflowCspAiTariffComponent } from "./workflow-csp-ai-tariff.component";

export const workflowCspAiTariffRouting: Routes = [
    { path: 'csp/change-ai-tariff/:aid', component: WorkflowCspAiTariffComponent, children: [
        { path: 'choose-ai-tariff', component: WorkflowCspAiTariffComponent, data: { step: 'choose-ai-tariff' } },
        { path: 'delivery-date', component: WorkflowCspAiTariffComponent, data: { step: 'delivery-date' } },
        { path: 'invoice-address', component: WorkflowCspAiTariffComponent, data: { step: 'invoice-address' } },
        { path: 'payment', component: WorkflowCspAiTariffComponent, data: { step: 'payment-method' } },
        { path: 'checkout-summary', component: WorkflowCspAiTariffComponent, data: { step: 'checkout-summary' } },
        { path: 'thank-you', component: WorkflowCspAiTariffComponent, data: { step: 'thank-you' } },
        { path: '', redirectTo: 'choose-ai-tariff', pathMatch: 'full' },
    ]},
]